
class SchoolSaleCountdown extends HTMLElement {
  constructor() {
    super();

    // 目标时间（美国时间）
    this.endTime = this.dataset.endTime;

    // 转成 America/New_York 时区的时间
    this.endTimeDate = new Date(
      new Date(this.endTime + " GMT-07:00").toLocaleString("en-US", {
        timeZone: "America/New_York"
      })
    );

    this.daysNumber = this.querySelector('#daysNumber');
    this.hoursNumber = this.querySelector('#hoursNumber');
    this.minutesNumber = this.querySelector('#minutesNumber');
    this.secondsNumber = this.querySelector('#secondsNumber');
    
    this.init();
  }

  init() {
    this.interval = setInterval(() => {
        const now = new Date();

        // 将当前时间转换为 America/New_York 时区
        const nowInUS = new Date(
          now.toLocaleString("en-US", { timeZone: "America/New_York" })
        );

        const leftTime = this.endTimeDate - nowInUS;

        if (leftTime < 0) {
            this.daysNumber.innerHTML = '00';
            this.hoursNumber.innerHTML = '00';
            this.minutesNumber.innerHTML = '00';
            this.secondsNumber.innerHTML = '00';
            clearInterval(this.interval);
            return;
        }

        let days = Math.floor(leftTime / (1000 * 60 * 60 * 24));
        let hours = Math.floor((leftTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((leftTime % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((leftTime % (1000 * 60)) / 1000);

        this.daysNumber.innerHTML = String(days).padStart(2, '0');
        this.hoursNumber.innerHTML = String(hours).padStart(2, '0');
        this.minutesNumber.innerHTML = String(minutes).padStart(2, '0');
        this.secondsNumber.innerHTML = String(seconds).padStart(2, '0');

    }, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

if (!window.customElements.get("school-sale-countdown-section")) {
    window.customElements.define("school-sale-countdown-section", SchoolSaleCountdown);
}
